import { useEffect } from 'react';
import { bootstrapAttribution } from '../lib/attribution';

/**
 * Nymia · Marketing Attribution capture bootstrap.
 *
 * Mounted once by App.js. On first render it reads the URL for UTM /
 * click-id params and persists them to session + local storage. All
 * subsequent reads (register, login, purchase snapshots) happen inside
 * the relevant handlers — this component never re-renders anything.
 */
const AttributionCapture = () => {
  useEffect(() => {
    bootstrapAttribution();
  }, []);
  return null;
};

export default AttributionCapture;
